module.exports = __webpack_public_path__ + "img/ic_department.79f870f3.svg";